<template>
  <div class="register-page">
    <div class="wrapper wrapper-full-page">
      <div
        class="full-page register-page section-image"
        filter-color="black">
        <div class="content">
          <div class="container">
            <div class="row">
              <div class="col-12 col-md-6 mx-auto">
                <card
                  type="signup"
                  class="text-center">
                  <template slot="header">
                    <h4 class="card-title">Réinitialisation du mot de passe</h4>
                  </template>
                  <fg-input
                    v-validate="modelValidations.newPassword"
                    ref="newPassword"
                    :error="getError('newPassword')"
                    v-model="form.newPassword"
                    class="px-md-3"
                    type="password"
                    name="newPassword"
                    placeholder="Nouveau mot de passe"
                  />
                  <fg-input
                    v-validate="modelValidations.confirmNewPassword"
                    :error="getError('confirmNewPassword')"
                    v-model="form.confirmNewPassword"
                    class="px-md-3 mb-3"
                    type="password"
                    name="confirmNewPassword"
                    placeholder="Confirmez le mouveau mot de passe"
                  />
                  <p-button
                    class="col-md-5 mx-0 my-1 my-md-3 mr-md-3"
                    type="info"
                    round
                    @click.prevent="backToLogin">Retour au Login</p-button>
                  <p-button
                    class="col-md-5 mx-0 my-1 my-md-3"
                    type="info"
                    round
                    @click.prevent="validate">Envoyer</p-button>
                </card>
              </div>
            </div>
          </div>
        </div>
        <div
          class="full-page-background"
          style="background-image: url(static/img/background/background-2.jpg) "
        />
      </div>
    </div>
  </div>
</template>
<script>
import { Card, Button } from 'src/components/Template';
import { Validator } from 'vee-validate';
import fr from 'vee-validate/dist/locale/fr';
import AxiosApiService from '@/services/axios/axios.api.service';

export default {
  components: {
    Card,
    [Button.name]: Button,
  },
  props: {
    email: {
      type: String,
      default: '',
    },
    secretKey: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      form: {
        newPassword: '',
        confirmNewPassword: '',
      },
      modelValidations: {
        newPassword: {
          required: true,
        },
        confirmNewPassword: {
          required: true,
          confirmed: 'newPassword',
        },
      },
    };
  },
  mounted() {
    // Set the field validator to french
    Validator.localize('fr', {
      messages: fr.messages,
      attributes: {
        newPassword: 'nouveau mot de passe',
        confirmNewPassword: 'de confirmation du mot de passe',
      },
    });
  },
  methods: {
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate() {
      this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          this.resetPassword();
          this.form.newPassword = '';
          this.form.confirmNewPassword = '';
          this.$validator.reset();
        } else {
          this.$notify({
            message: 'Veuillez corriger les erreurs.',
            icon: 'add_alert',
            type: 'danger',
            horizontalAlign: 'right',
            verticalAlign: 'bottom',
          });
        }
      });
    },
    async resetPassword() {
      try {
        const data = {
          email: this.email,
          secretKey: this.secretKey,
          newPassword: this.form.newPassword,
        };

        const response = await AxiosApiService.post('/reset/resetPassword', data);

        if (response) {
          this.$notify({
            message:
              'Mot de passe réinitialisé avec succès !',
            icon: 'add_alert',
            type: 'success',
            horizontalAlign: 'right',
            verticalAlign: 'bottom',
          });
          this.$router.push({ name: 'Login' });
        }
      } catch (error) {
        this.$notify({
          message: 'Echec de la réinitialisation du mot de passe, veuillez réessayer ou contacter le webmaster.',
          icon: 'add_alert',
          type: 'danger',
          horizontalAlign: 'right',
          verticalAlign: 'bottom',
        });
      }
    },
    backToLogin() {
      this.form.email = '';
      this.$validator.reset();
      this.$router.push({ name: 'Login' });
    },
  },
};
</script>
<style>
</style>
